import { Directive, inject, OnInit } from '@angular/core';
import { RequestsApiService } from '@core/services/request/requests-api.service';
import { FormPickerComponent } from '@core/components';

@Directive({
  selector: 'x-form-picker[xAttachCarBrands]',
  standalone: true,
})
export class AttachCarBrandsDirective implements OnInit {
  private readonly requestAPIService = inject(RequestsApiService);
  private readonly component = inject(FormPickerComponent);

  ngOnInit() {
    this.component.items$ = this.requestAPIService.getCarBrands$();
  }
}
